import { memo, useMemo } from 'react';
import styles from './FJSourceReviewItemStatus.module.less';
import PropTypes from 'prop-types';
import FJConstant from '../../../constants/FJConstant';
import FJLocalStore from '../../../store/FJLocalStore';
import ReloadIcon from '../../../assets/svg/reload.svg?react';
import FJResourceItemLoading from '../../../common/components/FJResourceItemLoading/FJResourceItemLoading';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';
import FJSourceErrorDisplay from './FJSourceErrorDisplay';
import FJAppConstant from '../../../constants/FJAppConstant';
import FJGenerating from '../../../common/components/FJResourceItemLoading/FJGenerating.jsx';
import useLocalStore from '../../../hooks/useLocalStore';

// data 用于处理特殊需求下需要的数据
const FJSourceReviewItemStatus = memo(
    ({ status, data, onRetry, onSourceReload, isVideoEffect, isRetryLoading, appType, isShowGenerating }) => {
        useLocalStore();
        const _onRetry = e => {
            e.stopPropagation();
            onRetry && onRetry();
        };

        const _onSourceReload = e => {
            e.stopPropagation();
            onSourceReload && onSourceReload();
        };
        const isShowRetryBtn = useMemo(() => {
            if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
                return true;
            }
            return String(data?.errorCode) !== '423';
        }, [appType, data?.errorCode]);
        return (
            <>
                {(status === FJConstant.PROGRESS || status === FJConstant.WAITING) &&
                    (() => {
                        const { generationType, originalUrl } = data;

                        return (
                            <div className={styles.wait_box}>
                                {generationType === 'iv' && originalUrl && (
                                    <>
                                        <img className={styles.bk_img} src={originalUrl} alt='' />
                                        <div className={styles.mask} />
                                    </>
                                )}
                                <div className={styles.content}>
                                    <div className={styles.wait_title}>
                                        {FJLocalStore._(
                                            status === FJConstant.PROGRESS ? 'generating_' : 'queuing-dots',
                                        )}
                                    </div>
                                    {/* TODO: 暂时隐藏等待时间 <div
                                    className={styles.wait_desc}
                                    dangerouslySetInnerHTML={{ __html: FJLocalStore._('estimate-wait-time') }}
                                /> */}
                                </div>
                            </div>
                        );
                    })()}

                {(status === FJConstant.ERROR || status === FJConstant.RETRY) &&
                    (() => {
                        return (
                            <div className={styles.new_retry_box}>
                                <FJSourceErrorDisplay data={data} isVideoEffect={isVideoEffect} />

                                {isShowRetryBtn && (
                                    <FJButton
                                        type={FJButtonType.DEFAULT}
                                        text={FJLocalStore._('retry')}
                                        className={styles.retry_btn}
                                        onClick={_onRetry}
                                        isLoading={isRetryLoading}
                                    />
                                )}
                            </div>
                        );
                    })()}

                {status === FJConstant.LOADING && (
                    <>{isShowGenerating ? <FJGenerating /> : <FJResourceItemLoading className={styles.loading} />}</>
                )}

                {/* 资源加载失败 */}
                {status === FJConstant.SOURCE_LOADING_ERROR &&
                    (() => {
                        return (
                            <div className={styles.retry_box}>
                                <ReloadIcon className={styles.reload_icon} onClick={_onSourceReload} />
                            </div>
                        );
                    })()}
            </>
        );
    },
);

FJSourceReviewItemStatus.displayName = 'FJSourceReviewItemStatus';

FJSourceReviewItemStatus.propTypes = {
    status: PropTypes.string.isRequired,
    data: PropTypes.object,
    onRetry: PropTypes.func,
    onSourceReload: PropTypes.func,
    isVideoEffect: PropTypes.bool,
    isRetryLoading: PropTypes.bool,
    appType: PropTypes.string,
};

export default FJSourceReviewItemStatus;
